export default __webpack_public_path__ + "static/codutech2-ff33bc5513a4feb36a53fdb1c93493a0.svg";